import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                                <section>
                                    <div className="">
                                        <div className="ilead-rgt people">
                                            <div className="innerpadding">
                                                <div className="innovativeimg">
                                                    <img
                                                        src={require('@images/how to actively listen.png')}
                                                        alt=""/>
                                                </div>

                                                <div className="ilead-contentarea">

                                                    <div className="circle_title"><img
                                                        src={require('@images/browndot.jpg')}
                                                        alt=""/>isn't it interesting?</div>
                                                    <p>You’re at a party. It’s busy. Inevitably, you find yourself in
                                                        the kitchen. After all, that’s where all great parties end up.
                                                        You’re talking to someone you’ve never met before and – despite
                                                        the five or six other noisy conversations going on around you –
                                                        following every word. A remarkable feat of listening skills. Or
                                                        is it?</p>

                                                    <div className="lightgreencontentbg keyquestionpad">
                                                        <div className="border_subtitle">‘Shaken…not stirred’</div>
                                                        <p>A long-standing phenomenon in psychology is known as the
                                                            ‘Cocktail party effect’.<a className="superscripttext"
                                                                                       href="further_info.php?course=300"><sup>1</sup></a> It
                                                            shows how our listening capacity, even in very busy
                                                            situations such as a cocktail party, can be strong but is
                                                            not entirely dependent on the words that we hear. We have an
                                                            ability to pick out and listen to a single voice, in a crowd
                                                            of voices, using the cues of physical differences as much as
                                                            listening to the spoken words.</p>
                                                        <p>Differences such as gender,<a className="superscripttext"
                                                                                         href="further_info.php?course=300"><sup>2</sup></a> intensity
                                                            of voice and speaker location <a className="superscripttext"
                                                                                             href="further_info.php?course=300"><sup>3</sup></a> all
                                                            have a considerable impact on our ability to maintain
                                                            attention on a single speaker in a crowded room. As soon as
                                                            these important cues were removed, the listener quickly lost
                                                            the ability to pay attention to the message. This in turn
                                                            meant that they struggled to remember the point or anything
                                                            about the person giving the message.</p>
                                                    </div>

                                                    <div className="border_subtitle">This tool can help</div>
                                                    <p>Listening clearly isn’t just about hearing a few words and
                                                        phrases. It involves engaging in
                                                        understanding and deciphering the real message rather than
                                                        selectively attending to information.
                                                        This tool is all about <span className="brown brownbold">how to actively listen</span> and
                                                        will help you to understand what is meant by
                                                        active listening and why it is important for effective
                                                        communication.</p>
                                                    <br/>

                                                        <div className="right-btn"><div
                                                            onClick={this.props.handleChangePage('Page2')}
                                                            className="button-next-previous-done">Next &gt;&gt;</div></div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}